import UserIcon from '@mui/icons-material/AccountCircle';

export default UserIcon;
